<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-sectionmargin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/partnership">Partnership Opportunities</a></li>
                            <!-- <li><a routerLink="/officialpartners" class="">Official Partners</a></li> -->
                            <li><a routerLink="/players-sponsor" class="active">Entry Level Sponsorship</a></li>
                            <li><a routerLink="/commercial" >Captain’s Club </a></li>
                            <!-- <li><a routerLink="/boundary">The Boundary Club</a></li> -->
                            <!--<li><a routerLink="/advertising">LED Big Screen Advertising</a></li>-->
                            <!-- <li><a routerLink="/indiafixture">India Fixture</a></li> -->
                            <li><a routerLink="/hospitality">Match Day Hospitality</a></li>
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="commercial-bottom-content">
            <div class="container">
                <div *ngFor="let player of playerList?.data?.other">
                    <div class="commercial-president-main-section cf">
                        <div class="commercial-president-section cf">
                            <div class="commercial-president-image-box">
                                <img [src]="player?.image">
                                <div class="commercial-president-btn">
                                    <a href="{{player?.pdf}}" target="_blank">Click HERE for full package</a>
                                </div>
                            </div>
                            <div class="commercial-president-content-box">
                                <div class="titel-box">
                                    <h2 class="titel-name">{{player?.title}}</h2>
                                </div>
                                <div class="commercial-president-content" [innerHTML]="player?.description">
                                    
                                </div>
                            
                            </div>
                        </div>
                    </div>
                    <div class="commercial-package-highlights" *ngIf="player?.amount != '.'">
                        <div class="commercial-package-highlights-left">
                            <div class="commercial-package-highlights-left-top">
                                <div class="package-rate">
                                    <h3>{{player?.amount}}</h3>
                                    <p>Plus. VAT</p>
                                </div>
                                <div class="package-highlights">
                                    <h3>{{player?.package_title}}</h3>
                                </div>
                            </div>
                            <div class="commercial-package-highlights-left-bottom" [innerHTML]="player?.package_description">
                                
                            </div>
                        </div>
                        <div class="commercial-package-highlights-right">
                            <div class="commercial-package-highlights-right-top">
                                <div class="package-highlights-right-image">
                                    <img src="assets/images/fox-white.png">
                                </div>
                            </div>
                            <div class="commercial-package-highlights-right-bottom">
                                <!-- <div class="package-highlights-right-image-box">
                                    <img [src]="player?.package_image">
                                </div> -->
                                <div class="package-highlights-right-content-box" [innerHTML]="player?.package_contact_description">
                                    
                                    <div class="package-highlights-right-content-btn">
                                        <a href="#">
                                            <p>{{player?.package_contact_name}}</p>
                                            <span>{{player?.package_contact_designation}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="commercial-boundary-section cf" *ngFor="let boundary of boundaryList?.data?.other">
                    <div class="commercial-president-main-section cf">
                        <div class="commercial-president-section cf">
                            <div class="commercial-president-content-box-main">
                                <div class="commercial-president-image-box">
                                    <img [src]="boundary?.image">
                                    <div class="commercial-president-btn" *ngIf="boundary?.pdf != ''">
                                        <a href="{{boundary?.pdf}}" target="_blank">Click HERE for full package</a>
                                    </div>
                                </div>
                                <div class="commercial-president-content-box">
                                    <div class="titel-box">
                                        <h2 class="titel-name">{{boundary?.title}}</h2>
                                    </div>
                                    <div class="commercial-president-content" [innerHTML]="boundary?.description">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="commercial-package-highlights" >
                        <div class="commercial-package-highlights-left">
                            <div class="commercial-package-highlights-left-top">
                                <div class="package-rate">
                                    <h3>{{boundary?.amount}}</h3>
                                    <p>Plus. VAT</p>
                                </div>
                                <div class="package-highlights">
                                    <h3>{{boundary?.package_title}}</h3>
                                </div>
                            </div>
                            <div class="commercial-package-highlights-left-bottom" [innerHTML]="boundary?.package_description">
                               
                            </div>
                        </div>
                        <div class="commercial-package-highlights-right">
                            <div class="commercial-package-highlights-right-top">
                                <div class="package-highlights-right-image">
                                    <img src="assets/images/fox-white.png">
                                </div>
                            </div>
                            <div class="commercial-package-highlights-right-bottom">
                                <!-- <div class="package-highlights-right-image-box">
                                    <img [src]="boundary?.package_image">
                                </div> -->
                                <div class="package-highlights-right-content-box" [innerHTML]="boundary?.package_contact_description">
                                    
                                    
                                    <div class="package-highlights-right-content-btn">
                                        <a href="#">
                                            <p>{{boundary?.package_contact_name}}</p>
                                            <span>{{boundary?.package_contact_designation}}</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="commercial-contact-us-section cf">
                    <div class="titel-box">
                        <h2 class="titel-name">{{playergeneralList?.title}}</h2>
                    </div>
                    <div class="commercial-contact-content" [innerHTML]="playergeneralList?.description">
                       
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/player-bg-img.png);">
            <div class="container">
                <div class="commercial-bottom-contact-detail">
                    <form class="commercialform " #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)" [ngClass]="{'success': contactSuccess}">
                        <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                        </http-message>
                        <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                           class="err-msg-block"></http-message>
                        <div class="join-register-right-box">
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="First Name" type="text">
                                </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Last Name" type="text">
                                </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Email Address" type="text">
                                </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="mobile_number" [(ngModel)]="contactRequest.mobile_number"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Mobile No" type="number">
                            </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="company_name" [(ngModel)]="contactRequest.company_name"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Company Name" type="text">
                            </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="type_of_event" [(ngModel)]="contactRequest.type_of_event"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Type of event" name="type_of_event" type="text" >
                            </app-form-field>
                            </div>
                            <div class="join-register-right-box-input full">
                                <app-form-field validation="required" name="message" [(ngModel)]="contactRequest.message"
                           class="app-group">
                                    <textarea appFieldInput name="message" form="usrform" class="register-style" placeholder="Message">Message</textarea>
                                </app-form-field>
                            </div>
                        </div>
                        <div class="join-register-right-box">
                            <div class="join-register-btn"><button id="reg_button" type="submit">Submit</button></div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="commercial-bottom-contact-overlay"></div>
        </div>
    </div>
</section><!-- page ends-->